<!--
 * @Description: 基础弹层组件
 * @Date: 2019-08-16 11:23:03
 -->
<template>
  <el-dialog v-bind="attrs" v-on="$listeners">
    <slot name="title"></slot>
    <div class="xrk-dialog-scroll">
      <slot></slot>
      <slot name="footer">
        <div
          class="xrk-dialog-footer"
          v-if="attrs.showCancel || attrs.showConfirm"
        >
          <el-button
            v-if="attrs.showCancel"
            :type="attrs.cancelType"
            @click="footerHandle('cannel')"
          >
            {{ attrs.cancelText }}
          </el-button>
          <el-button
            v-if="attrs.showConfirm"
            :type="attrs.confirmType"
            @click="footerHandle('confirm')"
          >
            {{ attrs.confirmText }}
          </el-button>
        </div>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      background: '#fff',
      visible: true,
      width: 'auto',
      title: '提示',
      top: '',
      center: true,
      'close-on-click-modal': false,
      'close-on-press-escape': false,
      'show-close': true,
      'custom-class': 'xrk-dialog',
      'before-close': this.beforeClose,
      'destroy-on-close': false,
      'modal-append-to-body': false,
      // 额外参数
      showDefaultFooter: false, // 是否使用默认footer
      showConfirm: true,
      confirmType: 'primary',
      confirmText: '确定',
      showCancel: true,
      cancelType: 'default',
      cancelText: '取消'
    };
  },
  components: {},
  watch: {},
  computed: {
    attrs() {
      return Object.assign(this.$data, this.$attrs);
    }
  },
  methods: {
    beforeClose(done) {
      this.visible = false;
      done && done();
    },
    footerHandle(event) {
      if (event === 'cannel') {
        this.beforeClose();
      }
      this.$emit('defaultBtEmit', event);
      if (
        this.success &&
        Object.prototype.toString.call(this.success) == '[object Function]'
      ) {
        this.success({
          confirm: event == 'confirm',
          content: this.$slots.default.componentInstance,
          dialog: this
        });
      }
    }
  },
  created() {},
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.default-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
<style lang="scss">
@import '~@/styles/mixin.scss';
@import '~@/styles/theme.scss';

.el-dialog__wrapper {
  // line-height: 1;
  .xrk-dialog {
    @include absolute_mid();
    width: auto;
    margin: 0;
    background-color: #fff;
    border-radius: $--radius-main * 1.5;
    .el-dialog__header {
      padding: 15px 0 15px;
      position: relative;
      z-index: 999;
      .el-dialog__title {
        font-size: 24px;
      }
      .el-dialog__headerbtn {
        top: 10px;
      }
    }
    .el-dialog__body {
      // padding: 32px 24px;
      // padding-top: 40px;
      padding-bottom: 0;
      transform: translateX(-1px) translateY(-10px);
      overflow-y: auto;
      max-height: 90vh;
    }
    &-scroll {
      // overflow-y: auto;
      // max-width: 90vw;
      // max-height: 70vh;
    }
    &-footer {
      width: 100%;
      margin-top: 32px;
      text-align: center;
      margin-bottom: 32px;
      .el-button + .el-button {
        margin-left: 35px;
      }
    }
  }
}

// .custom-dialog {
//   width: auto;
//   min-width: 600px;
//   max-width: 80%;
// }
// @import '@/styles/mixin.scss';
// .dialog {
//   .el-dialog {
//     width: 90vw;
//     /*标题样式*/
//     .el-dialog__header {
//       background-color: #5a9cf8;
//       padding: 0px;
//       height: 48px;
//       @include flex_mid;
//       .el-dialog__title {
//         font-size: 20px;
//         color: #ffffff;
//       }
//     }
//     /*输入框后面加<元>*/
//     .el-dialog__body {
//       padding: 30px;
//       border-bottom: 1px #dfe1e6 solid;
//       .el-form-item {
//         margin-bottom: 15px;
//       }
//     }
//     /*底部按钮居中和大小*/
//     .el-dialog__footer {
//       height: 89px;
//       padding: 0;
//       display: flex;
//       justify-content: center;
//       .dialog-footer {
//         align-self: center;
//         .el-button {
//           width: 155px;
//           height: 39px;
//         }
//       }
//     }
//   }
// }
//
</style>
